import React from 'react';

function NewAssessmentFlagIcon({ flagged }) {
  return (flagged
    ? (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
        <path fill="#FFFFFF" d="M5.81,1.59L1.58,5.84c-0.78,0.78-0.78,2.05,0,2.84L13.67,20.7c0.63,0.64,1.71,0.18,1.7-0.72l-0.05-3.69 c-0.01-0.56,0.45-1.02,1.01-1.02l3.66,0.05c0.89,0.01,1.35-1.08,0.72-1.71L8.62,1.59C7.84,0.8,6.58,0.8,5.81,1.59"/>
      </svg>
    ) : (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
        <path fill="#FFFFFF" d="M7.92,3.71l9.65,9.58l-2.24-0.03l0,0c-1.12-0.01-2.03,0.9-2.02,2.03l0.03,2.25L3.69,7.97 c-0.39-0.39-0.39-1.03,0-1.42l2.82-2.84C6.9,3.32,7.53,3.32,7.92,3.71 M5.81,1.59L1.58,5.84c-0.78,0.78-0.78,2.05,0,2.84L13.67,20.7 c0.63,0.64,1.71,0.18,1.7-0.72l-0.05-3.69c-0.01-0.56,0.45-1.02,1.01-1.02l3.66,0.05c0.89,0.01,1.35-1.08,0.72-1.71L8.62,1.59 C7.84,0.8,6.58,0.8,5.81,1.59"/>
      </svg>

    )
  );
}

export default NewAssessmentFlagIcon;



// WEBPACK FOOTER //
// ./src/components/icons/NewAssessmentFlagIcon.js